import React from 'react';
import './css/sidebar.css'
import { NavLink } from 'react-router-dom';
import kzLogo from './img/kz-logo-full-400.png';
import greenlineLogo from './img/greenline-logo.svg';
import { getBrandName, isMCPAvailable, isZapierAvailable } from './utils/brand';

const Sidebar = ({ onNavigate }) => {
    const host = window.location.host.toLowerCase();
    const isGreenline = host.includes('greenline.works');
    const brandName = getBrandName();
    let logo = kzLogo;
    let url = 'https://kanbanzone.com';

    if (isGreenline) {
        logo = greenlineLogo;
        url = 'https://greenline.works';
    }

    return (
        <nav id="primary-nav" className="side-bar" aria-label="Primary">
            <div className="side-bar-header">
                <a target="_blank" rel="noopener noreferrer" href={url}>
                    <img src={logo} alt={brandName} />
                </a>
            </div>
            <div className="side-bar-body">
                <h3>Documentation</h3>
                <div className="api-link"><NavLink activeClassName="active" to="/api" onClick={onNavigate}>API Reference</NavLink></div>
                <div className="api-link"><NavLink activeClassName="active" to="/webhooks" onClick={onNavigate}>Webhooks</NavLink></div>
                {isZapierAvailable() && <div className="api-link"><NavLink activeClassName="active" to="/zapier" onClick={onNavigate}>Zapier</NavLink></div>}
                <div className="api-link"><NavLink activeClassName="active" to="/changelog" onClick={onNavigate}>Changelog</NavLink></div>
                {isMCPAvailable() && <div className="api-link"><NavLink activeClassName="active" to="/mcp" onClick={onNavigate}>MCP Server</NavLink></div>}

                <h3>Tools</h3>
                <div className="api-link download">
                    <a href={isGreenline ? '/greenline-postman-collection.json' : '/kanbanzone-postman-collection.json'} download>
                        <span>Postman Collection</span>
                        <svg
                            className="icon-download"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.25"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            aria-hidden="true"
                        >
                            <path d="M12 3v12" />
                            <path d="m6 11 6 6 6-6" />
                            <path d="M5 21h14" />
                        </svg>
                    </a>
                </div>
            </div>
        </nav>
    );
};

export default Sidebar;
